import { PermissionsFacade } from "@webapp/permissions/services/permissions-facade.service";
import { UIRouterModule } from "@uirouter/angular";
import { NgModule } from "@angular/core";
import { ExamplesModule } from "./examples/examples.module";

const coreRoute = {
  name: "gh",
  abstract: true,
  resolve: [
    {
      token: "pemissions",
      deps: [PermissionsFacade],
      resolveFn: (permissionsFacade: PermissionsFacade): Promise<string[]> => {
        return permissionsFacade.loadEffectivePermissions();
      },
    },
  ],
};

const examplesRoute = {
  name: "gh.examples",
  url: "/examples",
  loadChildren: (): Promise<typeof ExamplesModule> => import("./examples/examples.module").then((m) => m.ExamplesModule),
};

const routes = [coreRoute, examplesRoute];

@NgModule({
  imports: [UIRouterModule.forChild({ states: routes })],
  exports: [UIRouterModule],
})
export class AppRoutingModule {}
